interface ShouldLoadPropertyPlmTasksArgs {
  canAccessPlm: boolean;
  pathname: string;
}

const PLM_UNIT_SECTIONS = new Set(['units', 'installer']);

export function shouldLoadPropertyPlmTasks({
  canAccessPlm,
  pathname,
}: ShouldLoadPropertyPlmTasksArgs): boolean {
  if (!canAccessPlm) {
    return false;
  }

  const pathParts = pathname.split('/').filter(Boolean);
  const isPropertyRoute = pathParts[0] === 'properties' && !!pathParts[1];
  if (!isPropertyRoute) {
    return false;
  }

  const unitSection = pathParts[2];

  if (!PLM_UNIT_SECTIONS.has(unitSection)) {
    return false;
  }

  const isUnitListRoute = pathParts.length === 3;
  const isUnitPlmCalendarRoute =
    pathParts.length === 5 && pathParts[4] === 'plm-schedule';

  return isUnitListRoute || isUnitPlmCalendarRoute;
}
